import React from 'react';

import { Form } from 'semantic-ui-react';

function formatearMonto(monto: number) {
    return monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function convertirANumero(texto: string) {
    const numero = parseInt(texto.replace(/[^0-9]/g, ''), 10);
    return isNaN(numero) ? 0 : numero;
}

interface MontoEInteresesProps {
    fechaRecepcionPago: string;
    monto: number;
    interes: number;
    numeroDeBoleta: string;
    pagoEsperado?: number;
    alCambiarCampo(nombreDelCampo: string, valor: string | boolean | number): void;
}

const MontoEIntereses: React.FunctionComponent<MontoEInteresesProps> = props => {
    const {
        fechaRecepcionPago,
        monto,
        interes,
        numeroDeBoleta,
        pagoEsperado,
        alCambiarCampo,
    } = props;
    return (
        <div>
            <Form.Input
                type='date'
                label='Fecha de pago'
                required
                value={fechaRecepcionPago}
                onChange={(_e, { value }) => {
                    alCambiarCampo('fechaRecepcionPago', value);
                }}
            />
            <Form.Input
                label='Monto'
                required
                error={pagoEsperado !== undefined && monto > pagoEsperado ? true : false}
                value={formatearMonto(monto)}
                onChange={(_e, { value }) => {
                    alCambiarCampo('monto', convertirANumero(value));
                }}
            />
            <Form.Input
                label='Interés'
                value={formatearMonto(interes)}
                onChange={(_e, { value }) => {
                    alCambiarCampo('interes', convertirANumero(value));
                }}
            />

            <Form.Input
                label='Número de boleta'
                placeholder='53210'
                required
                value={numeroDeBoleta}
                onChange={(_e, { value }) => {
                    alCambiarCampo('numeroDeBoleta', value);
                }}
            />
        </div>
    );
};

export default MontoEIntereses;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/MontoEIntereses.tsx